<template>
  <v-layout class="rights" row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >        
    <v-flex xs3 class="px-1"  style="flex-direction:column;align-items:stretch;height:100%;position:relative" >        
      <v-card class="mt-1 mb-2 ml-1 mr-2 maincontent"   > 
        <v-card-title style="flex-direction:column;align-items:stretch;height:100%;">
          <h2 style="flex:0 0 auto;">Historique des configurations</h2>        
          <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >          
            <div ref="liste" class="liste" style="overflow:auto">
              <div class="line-item" v-for="config in configs" :key="config.FLC_ID" >
                    <div class="heading ml-2" style="display:flex;">        
                      {{config.FLC_DATADD | formatDate}}
                      <v-spacer />
                      <v-btn icon small @click="showHisto(config)"><v-icon>mdi-code-tags</v-icon></v-btn>
                    </div>
                </div>
            </div>          
          </v-layout>  
        </v-card-title>        
      </v-card>
    </v-flex>
    <v-flex xs9 class="pa-2">        
        <v-textarea                   
          label="Configuration courante"
          v-model="config"        
          no-resize  
          :rows=rows
        ></v-textarea>
    </v-flex>
    <v-dialog
        v-model="showHistoConfig"
        hide-overlay
        persistent
        close
        scrollable
        width="700">
        <v-card  >
          <v-card-text>
             <json-viewer
                v-if="showHistoConfig"
                :value="histoConfig.FLC_RAW?JSON.parse(histoConfig.FLC_RAW):''"
                :expand-depth=3
                copyable          
                ></json-viewer>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="$store.myActions.ADMINFLEET_HIDE_HISTOCONFIG()" color="primary" flat >Close</v-btn>          
        </v-card-actions>
        </v-card>
      </v-dialog>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import { Watch} from 'vue-property-decorator'
import Component from 'vue-class-component'
import { AloDbFleetConfig, IAloDbFleetConfigConstParam } from '../../../models/alodb/AloDbFleetConfig'

@Component({
  name: 'AdminFleetConfig'
})
export default class AdminFleetConfig extends Vue {  

  config=""
  configContainerHeight=100
  rows=10

  created() {               
    if(this.fle_id) this.$store.myActions.ADMINFLEET_ENSURE_CONFIG_LIST(this.fle_id)
  }

  get original() {
    return this.$store.myGetters.originalAdmAdminFleet
  }
  
  get fle_id() {
    return this.original.FLE_ID
  }

  get configs(){
    return this.$store.myGetters.fleetConfigsByFleet[this.fle_id!]
  }

  get currentFleetConfig(){
    return this.$store.myGetters.currentFleetConfig
  }

  get showHistoConfig(){
    return this.$store.myGetters.showHistoConfig
  }

  get histoConfig(){
    return this.$store.myGetters.histoConfig
  }

  @Watch('fle_id')
  onFleIdChanged(newValue: number, oldValue: number) {
    this.$store.myActions.ADMINFLEET_ENSURE_CONFIG_LIST(newValue)
  }

  @Watch('currentFleetConfig')
  onCurrentFleetConfigChanged(newValue: AloDbFleetConfig, oldValue: AloDbFleetConfig) {
    this.config = newValue.FLC_RAW!
  }
  
  onResize() {      
    //@ts-ignore
    this.rows = Math.floor((this.$el.offsetHeight - 90) / 18)
  }

   /*Cycle de vie*/
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }

  sauvegarde() {        
    this.$store.myActions.ADMINFLEET_SAVE_CONFIG_REQUEST(new AloDbFleetConfig({
        FLE_ID:this.fle_id,
        FLC_RAW:this.config
      } as IAloDbFleetConfigConstParam))
  }
  
  annuler(){    
    this.config = this.currentFleetConfig.FLC_RAW!
  }

  showHisto(config:AloDbFleetConfig) {
    this.$store.myActions.ADMINFLEET_SHOW_HISTOCONFIG(config)
  }

  
  
}
</script>
<style>
.rights .v-table__overflow,.rights .v-datatable{
  overflow-x:hidden;
}
</style>